import { render, staticRenderFns } from "./filters-dropdown.vue?vue&type=template&id=c07e149c&scoped=true"
import script from "./filters-dropdown.ts?vue&type=script&lang=ts&external"
export * from "./filters-dropdown.ts?vue&type=script&lang=ts&external"
import style0 from "./filters-dropdown.scss?vue&type=style&index=0&id=c07e149c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07e149c",
  null
  
)

export default component.exports